import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faMobileAlt, faRedo, faLaptop, faTabletAlt} from '@fortawesome/free-solid-svg-icons';

export const LoopExplainerSection = (props) => {
    const action = props.action || "Execute";
    return (<section className="atf-section-padding">
                  <div className="container">
                      <div className="row justify-content-center clearfix">
                          <div className="col-lg-7 col-12 text-center align-self-center">
                              <div>
                                  <h2 className='heading-size' style={{ color:"var(--thm-black"}}>{action}. Learn. Improve. Repeat.</h2>
                                  <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "5px 0 30px 0" }}>PracticeLoop speeds up your feedback loop, so you can improve faster.</p>
                              </div>
                          </div>
                          <div className="col-lg-5 col-md-6 col-12 text-center">
                            <div className="atf-img-inner" style={{backgroundImage: 'url(./assets/img/smokebg_white_light_compressed.jpg)', backgroundRepeat: 'no-repeat'}}>
                                <div className="home-image-box">
                                    <div>
                                        <FontAwesomeIcon icon={faMobileAlt} style={{ color: 'var(--thm-color)', fontSize: '60px' }}></FontAwesomeIcon>
                                        <h3 className="shake-1">{action}</h3>
                                        <p>Take a {action.toLowerCase()} in front of your phone camera</p>
                                    </div>
                                    <div>
                                        <FontAwesomeIcon icon={faRedo} className="loopSpinner"></FontAwesomeIcon>
                                    </div>
                                    <div>
                                        <FontAwesomeIcon icon={faLaptop} style={{ color: 'var(--thm-color)', fontSize: '40px', marginBottom: '5px' }}></FontAwesomeIcon>
                                        <FontAwesomeIcon icon={faTabletAlt} style={{ color: 'var(--thm-color)', fontSize: '60px', margin: '0px 20px 0 20px' }}></FontAwesomeIcon>
                                        <FontAwesomeIcon icon={faMobileAlt} style={{ color: 'var(--thm-color)', fontSize: '40px', margin: '0px 25px 5px 5px' }}></FontAwesomeIcon>
                                        <h3 className="shake-2">Learn and improve</h3>
                                        <p>Learn from real-time replays and analysis</p>
                                    </div>
                                </div>
                            </div>
    
                        </div>
                      </div>
                  </div>
              </section>
    
    );
}

export default LoopExplainerSection;